export default __webpack_public_path__ + "static/media/go_to_market.966e7ec5.png";